var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AeCard',{staticClass:"ae-account-reverse",attrs:{"fill":"dark"}},[_c('main',[_c('AeQrCode',{attrs:{"data":_vm.address}}),_c('AeAddress',{attrs:{"address":_vm.address,"mode":"three-columns"}})],1),(_vm.name)?_c('span',{staticClass:"name",attrs:{"slot":"toolbar"},slot:"toolbar"},[_vm._v(" "+_vm._s(_vm.name)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }